document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.getElementById('hamburger-icon');
    const overlay = document.getElementById('menu-overlay');
    const pageMenuItems = document.querySelectorAll('#main-header .menu .menu-item');
    const parentPageMenuItems = document.querySelectorAll('#main-header .menu-overlay-items .menu-item-object-page.menu-item-has-children');

    parentPageMenuItems.forEach((parentItem) => {
        const linkElement = parentItem.querySelector('a');

        if (linkElement) {
            const arrow = document.createElement('span');
            arrow.classList.add('menu-arrow');
            arrow.innerHTML = `<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 17L9 9L1 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
            linkElement.appendChild(arrow);

            parentItem.addEventListener('click', (e) => {
                const childMenu = parentItem.querySelector('.sub-menu');
                const isClickOnArrow = e.target.closest('.menu-arrow');
                const isClickOnLink = e.target === linkElement;

                if (isClickOnArrow || isClickOnLink) {
                    e.preventDefault();

                    if (childMenu) {
                        if (childMenu.classList.contains('show')) {
                            childMenu.style.height = `${childMenu.scrollHeight}px`;
                            requestAnimationFrame(() => {
                                childMenu.style.height = '0';
                            });
                        } else {
                            childMenu.style.height = `${childMenu.scrollHeight}px`;
                            childMenu.addEventListener(
                                'transitionend',
                                () => {
                                    childMenu.style.height = 'auto';
                                },
                                { once: true }
                            );
                        }

                        childMenu.classList.toggle('show');
                        arrow.classList.toggle('rotated');
                    }
                }
            });
        }
    });

    pageMenuItems.forEach((item) => {
        item.classList.add('desktop-only');
    });

    hamburger.addEventListener('click', () => {
        overlay.classList.toggle('active');
    });

    const searchModal = document.querySelector('#menu-overlay .searchwp-modal-form-trigger-el');
    searchModal.appendChild(document.createElement('span')).textContent = 'Search';

    window.addEventListener('resize', () => {
        if (window.innerWidth > 861) {
            overlay.classList.remove('active');
        }
    });
});
